import React, { Fragment } from "react";
import { useForm } from "react-hook-form";
import {
  Row,
  Col,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Button,
} from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import JobSearch from "../../Components/Jobseeker/JobSearch";
import CandidateSearch from "../../Components/Recruiter/CandidateSearch";
const CandidateSearchPage = () => {
  return (
    <Fragment>
      <Breadcrumbs
        title="Search Candidate (Free Pool)"
        mainTitle="Search Candidate (Free Pool)"
      />
      <Container fluid={true}>
        <CandidateSearch />
      </Container>
    </Fragment>
  );
};

export default CandidateSearchPage;
